import React from 'react'
import { ButtonBase, withStyles } from '@material-ui/core'
import classNames from 'classnames'

const styles = (theme) => ({
  base: {
    padding: 5,
    [theme.breakpoints.down('sm')]: {
      padding: '20px 5px',
    },
    width: '100%',
    height: '100%',
    display: 'block',
    borderRadius: 8,
  },
  contained: {
    backgroundColor: theme.palette.secondary.main,
    border: '1px solid black',
    color: '#fff',
    boxShadow: theme.shadows[5],
    '&:hover': {
      backgroundColor: 'rgb(0, 53, 103)',
    },
  },
  outlined: {
    border: '1px solid',
    borderColor: 'rgba(1, 76, 148, 0.5)',
    color: theme.palette.secondary.main,
    '&:hover': {
      backgroundColor: 'rgba(1, 76, 148, 0.08)',
      borderColor: theme.palette.secondary.main,
    },
  },
  containedDisabled: {
    backgroundColor: theme.palette.grey[500],
    cursor: 'default',
    border: 0,
  },
  outlinedDisabled: {
    border: '1px solid',
    borderColor: theme.palette.grey[500],
    color: theme.palette.grey[500],
  },
  text: {
    fontSize: 12,
    textAlign: 'center',
    [theme.breakpoints.down('md')]: {
      fontSize: 12,
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 12,
    },
  },
})

export default withStyles(styles)(
  ({ Icon, children, disabled, classes, variant, ...props }) => {
    const variantName = variant || 'contained'

    return (
      <ButtonBase
        disabled={disabled}
        className={
          disabled
            ? classNames(classes.base, classes[`${variantName}Disabled`])
            : classNames(classes.base, classes[variantName])
        }
        {...props}
      >
        <div>
          <Icon style={{ fontSize: 33 }} />
        </div>
        <div className={classes.text}>{children}</div>
      </ButtonBase>
    )
  },
)
